import { render } from "./TrafficBlock.vue?vue&type=template&id=43fa85bf&scoped=true"
import script from "./TrafficBlock.vue?vue&type=script&lang=js"
export * from "./TrafficBlock.vue?vue&type=script&lang=js"

import "./TrafficBlock.vue?vue&type=style&index=0&id=43fa85bf&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43fa85bf"]])

export default __exports__